import request from '../utils/request';


//banner列表
export function bannerList(data) {
    return request({
        url: 'home/banner/list',
        method: 'post',
        data: data,
    });
}
//banner设置
export function setBanner(data) {
    return request({
        url: 'home/banner/add',
        method: 'post',
        data: data,
    });
}
//banner删除
export function delBanner(data) {
    return request({
        url: 'home/banner/del',
        method: 'post',
        data: data,
    });
}
//公告列表
export function articleList(data) {
    return request({
        url: '/home/article/list',
        method: 'post',
        data: data,
    });
}

//添加公告
export function saveArticle(data) {
    return request({
        url: 'home/article/save',
        method: 'post',
        data: data,
    });
}
//公告详情
export function articleInfo(data) {
    return request({
        url: 'home/article/info',
        method: 'post',
        data: data,
    });
}
//删除公告
export function delArticle(data) {
    return request({
        url: 'home/article/del',
        method: 'post',
        data: data,
    });
}
//广告图列表
export function avList(data) {
    return request({
        url: 'home/banner/banner',
        method: 'post',
        data: data,
    });
}
//广告图修改
export function saveAv(data) {
    return request({
        url: 'home/banner/banner_save',
        method: 'post',
        data: data,
    });
}
